import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';

import { ActivatedRoute, NavigationEnd, Router, RouterModule } from "@angular/router";
import { filter } from "rxjs/operators";
import { checkClickDuplicateMenu } from "../nav.util";
import { Subject, takeUntil } from "rxjs";
import { INavMenu } from "@layouts/components";
import { AppService } from "@core/services/app.service";
import { NavService } from "@core/services/nav.service";
import { uriConsts } from "@shared/constants";
import { isPlatformBrowser } from "@angular/common";
import { TranslocoModule } from "@jsverse/transloco";
import { NgxPermissionsModule } from "ngx-permissions";
import { ChangeDetectorRef } from '@angular/core';
import { log } from 'console';


@Component({
  selector: 'app-nav-horizontal',
  templateUrl: './nav-horizontal.component.html',
  standalone: true,
  styles: [`
    .dropdown-menu > .dropdown-submenu > .dropdown-item:after {
      content: "\\f105" !important;
    }

    .dropdown-toggle::after {
      font-size: .7rem !important;
    }

    .dropdown-menu > .dropdown-submenu > .dropdown-menu {
      max-height: 75vh;
      overflow-y: auto;
    }
    .navbar-nav-link.active, .navbar-nav-link.show, .navbar-nav-link[aria-expanded=true], .navbar-nav-link:focus, .navbar-nav-link:hover{
      background-color: var(--themeBg);
    }

  `],
  imports: [
    RouterModule,
    TranslocoModule,
    NgxPermissionsModule
  ]
})
/**
 * menu Ngang
 */
export class NavHorizontalComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed = new Subject();
  navItems: INavMenu[] = [];
  menuParentState: string = '';
  currentUrl: string = '';
  menuSubStates: string = '';
  @ViewChild('refNavBar') refNavBar!: ElementRef;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    public app: AppService,
    public render2: Renderer2,
    private route: ActivatedRoute,
    private router: Router,
    private navService: NavService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {

    this.navService.navItemsAllows$.pipe(takeUntil(this.destroyed)).subscribe(items => {
      this.navItems = items;
      // Sử dụng setTimeout để tránh lỗi ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        if (this.currentUrl) {
          this.markActiveMenu(this.navItems);
        }
        this.cdr.detectChanges();
      });
    });
    this.router.events
      .pipe(takeUntil(this.destroyed))
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe({
        next: () => {
          this.currentUrl = this.router.url.split('?')[0].split('#')[0]
          if (this.currentUrl) {
            this.markActiveMenu(this.navItems);
          }
        }
      });

    this.route.paramMap.pipe(takeUntil(this.destroyed)).subscribe({
      next: () => {
        this.currentUrl = this.router.url.split('?')[0].split('#')[0]
        if (this.currentUrl) {
          this.markActiveMenu(this.navItems);
        }
      }
    })
  }



  ngOnDestroy(): void {
    this.destroyed.next(null);
    this.destroyed.complete();
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.render2.listen('window', 'click', (e: Event) => {
        if (this.refNavBar) {
          if (!this.refNavBar.nativeElement.contains(e.target)) {
            this.closeAll();
          }
        }
      });
    }
  }

  private markActiveMenu(navItems: INavMenu[]) {
    navItems.forEach(item => {
      item.active = false;
    });

    navItems.forEach((item: INavMenu) => {
      if (item.url === this.currentUrl) {
        item.active = true;
        return;
      }

      if (item.children && item.children.length) {
        this.markActiveMenu(item.children);

        if (item.children.some(child => child.active)) {
          item.active = true;
        }
      }
    });
  }


  onHandleClick(url?: string) {
    if (url) {
      checkClickDuplicateMenu(url, this.app)
    }

    setTimeout(() => this.closeAll(), 10)
  }


  toggleParentMenu(menuId: number, $event?: Event) {
    if ($event) {
      $event.stopPropagation();
    }
    const key = `root_${menuId}`;
    this.menuParentState = this.menuParentState == key ? '' : key;
  }

  toggleSubMenu(menuId: number, $event: Event) {
    $event.stopPropagation();
    const key = `sub_${menuId}`;
    this.menuSubStates = this.menuSubStates == key ? '' : key;
  }

  private closeAll() {
    this.menuParentState = '';
    this.menuSubStates = '';
  }

  openSubMenu(idx: number) {
    this.menuSubStates = 'sub_' + idx;
  }

  closeSubMenu(idx: number) {
    if (this.menuSubStates === 'sub_' + idx) {
      this.menuSubStates = '';
    }
  }

  readonly uriConsts = uriConsts;
}
